import { VCard } from 'vuetify/lib/components/VCard';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VCard,
        [
          _c(
            "div",
            { staticClass: "text-right pa-2" },
            [
              _vm.hideAssignAllTables
                ? _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "outline-primary" },
                      on: {
                        click: function ($event) {
                          return _vm.openAllTempOwner()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons md-16" }, [
                        _vm._v("done_all"),
                      ]),
                      _vm._v(
                        _vm._s(_vm.$t("botones.boton_dashboard_all_operator"))
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("b-table", {
            staticClass: "text-center",
            style: { "font-size": "11px" },
            attrs: {
              responsive: "",
              hover: "",
              fields: _vm.workBookFields,
              items: _vm.tableau_workbook,
              "show-empty": "",
              busy: _vm.isBusy,
            },
            scopedSlots: _vm._u([
              {
                key: "table-busy",
                fn: function (scope) {
                  return [_c("strong", [_vm._v(_vm._s(_vm.messageLoading))])]
                },
              },
              {
                key: "empty",
                fn: function (scope) {
                  return [
                    _c("strong", [_vm._v(_vm._s(_vm.messageEmptyTableauWb))]),
                  ]
                },
              },
              {
                key: "cell(object_name)",
                fn: function (row) {
                  return [
                    _c("div", { staticClass: "text-left" }, [
                      _c("b", [
                        _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.changeMetaWorkBook(row.item, true)
                              },
                            },
                          },
                          [_vm._v(_vm._s(row.item.object_name))]
                        ),
                      ]),
                      _c("br"),
                      _c("a", {
                        domProps: {
                          innerHTML: _vm._s(_vm.composeName(row.item)),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeMetaWorkBook(row.item, true)
                          },
                        },
                      }),
                    ]),
                  ]
                },
              },
              {
                key: "cell(total_datasources)",
                fn: function (row) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.total_datasources(row.item))),
                    ]),
                  ]
                },
              },
              {
                key: "cell(actions)",
                fn: function (row) {
                  return [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.isDataOperator(row.item) ||
                              (!_vm.isDataOperator(row.item) &&
                                row.item.environment === "prod"),
                            expression:
                              "isDataOperator(row.item) || (!isDataOperator(row.item) && row.item.environment === 'prod')",
                          },
                        ],
                        staticClass: "btn-opt ml-1 mr-1",
                        attrs: {
                          size: "sm",
                          variant: "outline-primary",
                          title: "Update Metadata",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeMetaWorkBook(row.item, false)
                          },
                        },
                      },
                      [_c("b-icon", { attrs: { icon: "pencil-fill" } })],
                      1
                    ),
                    _vm.isDataOperator(row.item) &&
                    row.item.environment === "prod"
                      ? _c(
                          "b-button",
                          {
                            staticClass: "btn-opt ml-1 mr-1",
                            attrs: {
                              size: "sm",
                              variant: "outline-primary",
                              title: "Set Temporal data operator",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.openTempOwner(row.item)
                              },
                            },
                          },
                          [_c("b-icon", { attrs: { icon: "people-fill" } })],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isDataOperator(row.item),
                            expression: "isDataOperator(row.item)",
                          },
                        ],
                        staticClass: "btn-opt ml-1 mr-1 btn-sync",
                        attrs: {
                          size: "sm",
                          variant: "outline-primary",
                          title: "Sync Dashboard",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.syncTableauWorkbook(row.item)
                          },
                        },
                      },
                      [_c("b-icon", { attrs: { icon: "arrow-clockwise" } })],
                      1
                    ),
                  ]
                },
              },
              {
                key: "cell(rol)",
                fn: function (row) {
                  return [
                    _c(
                      "b-button",
                      {
                        attrs: {
                          size: "sm",
                          variant: "outline-primary",
                          href: row.item.access_link,
                          target: "_blank",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isDataOperator(row.item),
                                expression: "isDataOperator(row.item)",
                              },
                            ],
                          },
                          [_vm._v("Data operator")]
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isDataOperator(row.item),
                                expression: "!isDataOperator(row.item)",
                              },
                            ],
                          },
                          [_vm._v("viewer")]
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination-tableau", {
        attrs: { page: _vm.pageWb, limit: _vm.limit, rows: _vm.totalRowsWb },
        on: { onPage: _vm.onPageWorkBook },
      }),
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.MODAL_CHANGE_METADATA_WORKBOOK,
            size: "xl",
            "hide-footer": "",
          },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function () {
                return [
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.isReadonly,
                          expression: "!isReadonly",
                        },
                      ],
                    },
                    [_vm._v("Change")]
                  ),
                  _c("span", [_vm._v("Metadata Workbook")]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("form-meta-dashboard", {
            attrs: {
              item: _vm.data_wb,
              isChangeRequest: _vm.isReadonly
                ? _vm.ACCESS_TYPE_FLOW.ACCESS
                : _vm.ACCESS_TYPE_FLOW.CHANGE_METADATA,
              readonly: _vm.isReadonly,
              showButtons: !_vm.isReadonly,
            },
            on: { onCloseModal: _vm.onCloseModalworkBook },
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        { attrs: { "hide-footer": "", id: _vm.MODAL_NAME_OWNER } },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("Assign temporal operator"),
          ]),
          _c(
            "div",
            { staticClass: "d-block" },
            [
              _c("form-assign-temporal-owner", {
                attrs: { tplToWork: _vm.data_wb, type: "workbook" },
                on: {
                  submitDashboard: _vm.assignOwner,
                  cancel: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_NAME_OWNER)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "b-modal",
        { attrs: { "hide-footer": "", id: _vm.MODAL_NAME_ALL_OWNER } },
        [
          _c("template", { slot: "modal-title" }, [
            _vm._v("Assign dashboard tables to temporal operator"),
          ]),
          _c(
            "div",
            { staticClass: "d-block" },
            [
              _c("form-assign-temporal-owner", {
                attrs: {
                  type: "workbook",
                  isForAllOwners: true,
                  records: _vm.tableau_workbook,
                },
                on: {
                  submitDashboard: _vm.assignAllOwner,
                  cancel: function ($event) {
                    return _vm.$bvModal.hide(_vm.MODAL_NAME_ALL_OWNER)
                  },
                },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }